import { FC } from 'react';
import { IconButton, Modal } from '@mui/material';
import { CloseIcon, Colors } from '@sweatpals/react-ui-kit';
import { JoinWaitlist, JoinWaitlistProps } from './join-waitlist.component';

export interface JoinWaitlistModalProps extends JoinWaitlistProps {
	open: boolean;
	onClose(): void;
}

export const JoinWaitlistModal: FC<JoinWaitlistModalProps> = ({ open, onClose, ...joinWaitlistProps }) => (
	<Modal
		open={open}
		onClose={onClose}
		component='div'
		sx={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		}}
	>
		<JoinWaitlist
			{...joinWaitlistProps}
			onAlreadyJoinedConfirmButtonClick={onClose}
			sx={{	width: '515px', borderRadius: '8px' }}
			Header={() => (
				<IconButton
					onClick={onClose}
					sx={{
						position: 'absolute',
						top: '12px',
						right: '12px',
						color: Colors.white,
					}}
				>
					<CloseIcon />
				</IconButton>
			)}
		/>
	</Modal>
);
